<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" />
			<div class="btngroup">
				<CommonBtngroup ref="MyApprovalbtngroup" marginRight="45px" :qhide="false" @select="handSearch"
					@reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable" style="display: flex;flex: 1;width: 100%;align-items: center;margin-bottom:0px;">
			<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
		<!--v-if="auth.includes('delete')"-->
			<Commonbtn  backgroundColor="#FFF" title="删除" fontSize="14px"
				@btnclick="handDelete" :src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('browse')" backgroundColor="#FFF" :src="require('@/assets/icon/look.png')"
				title="查看" fontSize="14px" @btnclick="update(true)" :optional="selectIds.length !== 1">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" @onRowClick="(e) => tableCurr = e" :color="true" width="1000px" colnum=7
				:tableData="tableData" :headerData="headerData" height="100%"
				@handleSelectionChange="(e) => selectIds = e.map(item => item.RLDID)">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>

		<DialogFrom width="750px" :title="dialogLook ? '查看' : tableCurr ? '修改' : '新增'"
			:OKASCAN="!dialogLook ? true : false" :dialogVisible="dialogShow" @cancel="cancelEditor"
			@dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod" />
			<div class="box-opt" style="padding:18px 6px" :style="{ visibility: !dialogLook ? 'visible' : 'hidden' }">
				<Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="handShowPrd"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>

				<Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="handDelPrd"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div class="customer-table">
				<el-table :data="produData" style="width: 100%;" height="400px"
					@selection-change="(e) => tableDataSel = e.map(it => it.Level3Code)">
					<el-table-column type="selection" width="60" v-if="!dialogLook" />
					<el-table-column prop="Level3Name" label="产品名称" />
					<el-table-column prop="Quantity" label="数量">
						<template slot-scope="scope">
							<el-input v-model="scope.row.Quantity" :disabled="dialogLook" placeholder="请输入数量" />
						</template>
					</el-table-column>
				</el-table>
			</div>
		</DialogFrom>

		<DialogFrom width="550px" :title="`选择产品型号`" :dialogVisible="dialogVisibPrd" @cancel="dialogVisibPrd = false"
			:OKASCAN="false">
			<div class="from">
				<div class="flexBtn">
					<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" style="margin-left:0px !important;"
						@btnclick="handAddPrd" />
				</div>
				<Commontable ref="comtable" style="margin-left: 0%;" colnum=7 :tableData="tableDataPrd"
					:headerData="headerDataPrd" height="100%" @handleSelectionChange="(e) => tableDataSel = e">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
import FromComm from '../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '../../../../components/commongroup.vue'
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import Pagination from '../../../../components/pagination.vue'
import CommonbtnUpLoad from '../../../../components/common-upload.vue'
import Commontable from '../../../../components/common-table.vue'
import Dialog from '../../../../components/dialog.vue'
import FromArr from './FormData/FromArr'
import FromArrEditor from './FormData/FromArrEditor'
import headerData from './TableData/headerData'
import utils from "../../../../common/utils";
import {
	HospitalList,
} from '@/api/home'
import {
	GetRankingTransformer1011List,
	AddRankingTransformer1011Data,
	EditRankingTransformer1011Data,
	DelRankingTransformer1011Data,
	ExportRankingTransformer1011Data,
	GetProvinceRegion,
	GetHelperLevel3ForTransformer1011
} from '@/api/newsapi'
export default {
	components: {
		FromComm,
		CommonBtngroup,
		Commondropdownlist,
		Commonbtn,
		DialogFrom,
		Dialog,
		Pagination,
		CommonbtnUpLoad,
		Commontable
	},
	data() {
		return {
			total: 0,
			query: {
				pageIndex: 1,
				pageSize: 10
			},
			dialogShow: false,
			FromArr: [],
			FromArrEditor: [],
			tableCurr: null,
			tableInfo: null,
			tableData: [],
			headerData: [],
			dialogVisibleDel: false, //删除弹窗
			tableDatadrjg: [],
			selectIds: [],
			dialogVisibPrd: false,
			dialogLook: false,
			produData: [], // 选中后产品数据
			headerDataPrd: [{
				types: 'selection',
				label: '复选框',
			},
			{
				prop: 'Text',
				label: '产品名称'
			}],
			tableDataPrd: [], //产品弹窗表格数据
			tableDataSel: [], //产品弹窗选中数据
			auth: [],
			dialogReturnShow: false,
		}
	},
	mounted() {
		this.FromArr = JSON.parse(JSON.stringify(FromArr))
		this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
		this.headerData = JSON.parse(JSON.stringify(headerData))
		this.getData();
		this.getProvinceRegion();
		this.setMenuList();
	},
	computed: {
		menusData() {
			return this.$store.state.MenusData.CusWebMenus;
		}
	},
	methods: {
		//列表数据
		async getData() {
			this.query.Inventory = this.FromArr[0].modelvalue;
			this.query.HospitalName = this.FromArr[1].modelvalue;
			this.query.ImplantType = this.FromArr[2].modelvalue;
			this.query.Date1 = this.FromArr[3].StartTime;
			this.query.Date2 = this.FromArr[3].EndTime;
			this.query.ProvinceID = this.FromArr[4].modelvalue ? this.FromArr[4].modelvalue.join(',') : '';
			this.query.SalesManName = this.FromArr[5].modelvalue;

			let {
				code,
				data
			} = await GetRankingTransformer1011List(this.query)
			if (code == 0) {
				this.total = data.Count;
				this.tableData = data.data.map(it => {
					it.Level3Name = it.LEVEL3;
					it.CreateTimeTxt = it.CreateTime.substring(0, 16);
					return it;
				});
			}
		},
		//导出
		async handExport(e) {
			const loading = this.$loading({
				lock: true,
				text: '正在导出...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			this.query.Inventory = this.FromArr[0].modelvalue;
			this.query.HospitalName = this.FromArr[1].modelvalue;
			this.query.ImplantType = this.FromArr[2].modelvalue;
			this.query.Date1 = this.FromArr[3].StartTime;
			this.query.Date2 = this.FromArr[3].EndTime;
			this.query.ProvinceID = this.FromArr[4].modelvalue ? this.FromArr[4].modelvalue.join(',') : '';
			this.query.SalesManName = this.FromArr[5].modelvalue;

			let resexprot = await ExportRankingTransformer1011Data(this.query)
			loading.close();
			if (resexprot) {
				let date = new Date()
				let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
				utils.downloadFile(resexprot, `擎天柱龙虎榜${str}`, "xlsx")
			} else {
				// 返回json
				this.$message.error('导出失败');
			}
		},
		//获取省份
		async getProvinceRegion() {
			let {
				data,
				code
			} = await GetProvinceRegion({})
			if (code == 0) {
				this.FromArr[4].options = data.map(it => {
					it.key = it.Value;
					it.value = it.Text;
					return it;
				});
			}
		},
		handSearch() {
			this.query.pageIndex = 1;
			this.getData();
		},
		handReset() {
			this.query = {
				pageIndex: 1,
				pageSize: 10
			};
			this.FromArr.map((item, index) => {
				if (index === 6) {
					item.StartTime = '';
					item.EndTime = '';
				}
				item.modelvalue = '';
				return item;
			})
			this.getData();
		},
		add() {
			this.produData = [];
			this.dialogLook = false;
			this.dialogShow = true;
			this.tableCurr = null;
			this.FromArrEditor.map((item, index) => {
				item.modelvalue = '';
				item.disabled = false;
				return item;
			})
		},
		//删除
		handDelete() {
			if (!this.selectIds.length) {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$confirm(`确认要删除这些信息吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				dangerouslyUseHTMLString: true
			}).then(async () => {
				const loading = this.$loading({
					lock: true,
					text: '删除中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await DelRankingTransformer1011Data({
					RLDIDs: this.selectIds
				})
				loading.close();
				if (code == 0) {
					this.tableCurr = null;
					this.selectIds = [];
					this.$message.success('已删除');
					this.handSearch();
					this.$refs.refTableCenter.$refs.multipleTable.clearSelection();
				} else {
					this.$message.error(message);
				}
			}).catch(() => { });
		},
		//编辑
		async update(look = false) {
			if (this.selectIds.length === 1) {
				const row = this.tableData.find(item => item.RLDID === this.selectIds[0]);
				if (row) this.tableCurr = row;
			}
			if (!this.tableCurr) {
				this.$message.error('请先选择数据');
				return;
			}
			this.dialogLook = look;
			this.FromArrEditor[0].modelvalue = this.tableCurr.ImplantType + '';
			this.FromArrEditor[1].modelvalue = this.tableCurr.SurgeryTime != null ? String(this.tableCurr.SurgeryTime) : undefined;
			this.FromArrEditor[2].modelvalue = this.tableCurr.Hospital;
			this.FromArrEditor[2].options = [{
				label: this.tableCurr.HospitalName,
				value: this.tableCurr.Hospital
			}];
			this.FromArrEditor[3].modelvalue = this.tableCurr.TechnicalOffices;
			this.FromArrEditor[4].modelvalue = this.tableCurr.Doctor;
			this.produData = [{
				Level3Name: this.tableCurr.Level3Name,
				Level3Code: this.tableCurr.Level3Code,
				Quantity: this.tableCurr.Quantity,
			}];
			this.FromArrEditor.map((item, index) => {
				item.disabled = look;
				return item;
			})
			this.dialogShow = true;
			this.$forceUpdate();
		},
		//模糊查询
		async remoteMethod(val) {
			if (!val.parsign) return;
			let {
				code,
				data
			} = await HospitalList({
				HPName: val.qurey,
				HosType: '医院',
				IsTerminalHPOnly: 1,
				IncludeCity: 1
			})
			if (code == 0) {
				this.FromArrEditor[2].options = []
				data.data.forEach((item, index) => {
					let obj = {
						label: item.HPName,
						value: item.HPID,
					}
					this.FromArrEditor[2].options.push(obj)
				})
			}
		},
		//取消编辑
		cancelEditor() {
			this.FromArrEditor = this.FromArrEditor.map((item, index) => {
				item.modelValue = undefined;
				item.modelvalue = '';
				return item;
			})
			this.tableCurr = null;
			this.dialogShow = false;
			this.$forceUpdate();
		},
		async dialogOKEditor() {
			let params = {};
			this.FromArrEditor.map(item => {
				params[item.key] = (item.modelValue !== undefined && item.modelValue !== null && item.modelValue !== '') ? item.modelValue : (item.modelvalue !== undefined && item.modelvalue !== null && item.modelvalue !== '' ? item.modelvalue : null);
			})
			// 专门处理 SurgeryTime 传 0 的情况
			if (params.SurgeryTime === "0" || params.SurgeryTime === 0) {
				params.SurgeryTime = "0";
			}
			params.DetailLists = this.produData;
			if (this.tableCurr) {
				params.RLMID = this.tableCurr.RLMID;
				let {
					code,
					data,
					message
				} = await EditRankingTransformer1011Data(params)
				if (code == 0) {
					this.$message.success('编辑成功');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			} else {
				let {
					code,
					data,
					message
				} = await AddRankingTransformer1011Data(params)
				if (code == 0) {
					this.$message.success('新增成功');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			}
		},
		handleCurrentChange(e) {
			this.query.pageIndex = e
			this.getData()
		},
		handleSizeChange(e) {
			this.query.pageSize = e
			this.getData()
		},
		handShowPrd() {
			if (!this.FromArrEditor[0].modelvalue) {
				this.$message({
					type: 'error',
					message: '请选择今/明植入！'
				});
				return;
			}
			this.tableDataSel = [];
			this.dialogVisibPrd = true;
			if (this.tableDataPrd.length === 0) {
				this.handSelectPrd();
			}
		},
		//产品弹窗查询
		handSelectPrd() {
			this.getHelperLevel3();
		},
		/*
		 *选择产品部分
		 **/
		//查询绑定数据
		async getHelperLevel3() {
			let {
				data,
				code,
				message
			} = await GetHelperLevel3ForTransformer1011()
			if (code == 0) {
				if (data) {
					this.tableDataPrd = data;
					this.$nextTick(() => {
						this.$refs.comtable.$refs.multipleTable.clearSelection();
					})
				}
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		//产品弹窗保存
		handAddPrd() {
			if (!this.tableDataSel.length) {
				this.$message({
					type: 'error',
					message: '请勾选'
				});
				return;
			}
			this.dialogVisibPrd = false;
			this.produData = this.produData.concat(JSON.parse(JSON.stringify(this.tableDataSel.map(it => {
				return {
					Level3Name: it.Text,
					Level3Code: it.Value,
					Quantity: '',
				}
			}))));
		},
		//删除指定数据
		handDelPrd() {
			this.produData = this.produData.filter(item => !this.tableDataSel.includes(item.Level3Code));
		},
		//设置权限
		setMenuList() {
			let NodeInfo = this.menusData.filter(item => item.NodeID === '77')[0].Nodes.filter(item => item.NodeID ===
				'1081')[0].Nodes.filter(item => item.NodeID === '1115')[0].Buttons;
			console.log(666666, NodeInfo)
			this.auth = NodeInfo.map(it => it.NodeName);
		},
	}
}
</script>

<style lang="less" scoped>
.TopSearch {
	height: 180px;
	margin: 16px 0px 8px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

	.btngroup {
		// border: 1px solid #0b65ec;
		position: relative;
		bottom: 20px;
		right: 12px;

		.chackboxtow {
			display: inline-block;
			// border: 1px solid red;
			font-size: 14px;
			color: #333333;
			position: absolute;
			right: 300px;
			top: 20px;

			/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
				color: #e71d43;
			}
		}
	}
}

.BottomTable {
	margin-bottom: 14px;
}

.customer-table {
	/deep/.el-table .el-table__cell {
		padding: 2px 0px !important;
	}

	/deep/.el-input__inner {
		background-color: transparent;
		border: none;
		padding: 0 0px;
	}

	/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #e71d43;
		border-color: #e71d43;
	}
}

.select-table {
	border: 1px solid #00266D;
}

/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
	background-color: #e71d4399;
	color: #ffffff;
}
</style>